<template>
    <div class="container">
        <div class="LifeResult__content container-inner">
            <TitleSection
                title="Estimate of life cover"
            />
            <Result
                url="https://life.nib.com.au/life-insurance/quote#/intro"
                type="Life"
                label="Cover:"
                :result="insurance"
                @reset="reset"
            />
        </div>

        <slot />
    </div>
</template>

<script>
  import lifeDetailed from './../calculators/life-detailed';
  import lifeExpress from './../calculators/life-express';
  import TitleSection from '../components/TitleSection.vue';
  import Result from '../components/Result.vue';
  import * as track from '@/utilities/tracking';

  export default {
    name: 'results',

    components: {
        TitleSection,
        Result
    },

    computed: {
        insurance() {
            const debt = this.$store.state.customDebts || this.$store.state.debts;
            const expensesWeekly = this.$store.state.expenses || this.$store.state.customExpenses;
            const otherIncomeAnnual = this.$store.state.incomeOther || this.$store.state.customIncomeOther
            const childCount = this.$store.state.childrenNumber || this.$store.state.customChildrenNumber;
            const schoolType = this.$store.state.school;
            const childAges = this.$store.state.childrenAge;

            let result
            if (this.$store.state.calculator == 'detailed') {
                result = lifeDetailed(
                    debt, 
                    expensesWeekly, 
                    otherIncomeAnnual, 
                    schoolType, 
                    childAges,
                    this.$store.getters.getAssumptions
                );
            } else {
                result = lifeExpress(debt, this.$store.state.funeralCost);
            }

            return '$' + (Math.round(result)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },
    mounted() {
        track.completeLife();
    },
    methods: {
        reset() {
            track.resetLife();
            this.$store.commit('reset');
            this.$router.push({ path: `/life`});
        }
    }
  }
</script>

<style lang="scss" scoped>

    .LifeResult__content {
        max-width: 480px;
        margin: 0 auto;
        text-align: center;
        padding-bottom: 20px;
    }


    .LifeResult__list:after {
        content: "";
        display: table;
        clear: both;
    }

</style>
